import * as yup from 'yup';
import { ImageDropdown } from '@web/components';
import { linkSchema, requiredImageFromCMSSchema } from '../schemas';

export const component = ImageDropdown;

const dropdownItemSchema = yup
  .object({
    id: yup.string().required(),
    heading: yup.string().required(),
    summaryLabel: yup.string(),
    linkText: yup.string().required(),
    link: linkSchema.required(),
    image: requiredImageFromCMSSchema,
    altText: yup.string().required(),
  })
  .transform(value => ({
    ...value,
    imageSrc: value.image[0]?.asset?.url || value.image[0]?.url || '',
    link: value.link[0]?.url || value.link,
  }));

export const schema = yup
  .object({
    heading: yup.string(),
    helperText: yup.string(),
    defaultText: yup.string(),
    maxSelections: yup.number().positive().integer().nullable(),
    image: requiredImageFromCMSSchema,
    altText: yup.string(),
    items: yup.array().of(dropdownItemSchema),
  })
  .transform(value => ({
    heading: value.heading,
    helperText: value.helperText,
    defaultText: value.defaultText,
    maxSelections: value.maxSelections,
    imageSrc: value.image[0]?.asset?.url || value.image[0]?.url || '',
    altText: value.altText,
    items: value.items || [],
  }));
